import isShorterThan from './isShorterThan'

// returns true if input array's length is less than 0

const isShort = isShorterThan(1)

export default isShort